import { Title3, defaultStyle } from '@signavio/ui';
import { getEntityDisplayName } from '@signavio/effektif-api';
import { Markdown } from '@signavio/effektif-commons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function GroupInstance({
  children,
  groupInstance,
  style
}) {
  return /*#__PURE__*/_jsxs("div", {
    ...style,
    children: [/*#__PURE__*/_jsx(Title3, {
      children: getEntityDisplayName(groupInstance.name, 'group')
    }), groupInstance.description && /*#__PURE__*/_jsx("div", {
      ...style('description'),
      children: /*#__PURE__*/_jsx(Markdown, {
        children: groupInstance.description
      })
    }), children]
  });
}
const styled = defaultStyle(({
  color,
  font,
  padding
}) => ({
  marginTop: padding.normal,
  marginBottom: padding.normal,
  description: {
    fontSize: font.size.button,
    marginBottom: padding.normal
  }
}));
export default styled(GroupInstance);